import { Backend } from '@/_axios';

export default {
  list(projectId, params) {
    return Backend.get(`/project/${projectId}/project_tags/`, { params });
  },
  createData(projectId) {
    return Backend.get(`/project/${projectId}/project_tags/create`);
  },
  editData(projectId, id) {
    return Backend.get(`/project/${projectId}/project_tags/${id}/edit`);
  },
  create(projectId, data) {
    return Backend.post(`/project/${projectId}/project_tags/`, data);
  },
  update(projectId, data) {
    return Backend.put(`/project/${projectId}/project_tags/${data.id}`, data);
  },
  delete(projectId, id) {
    return Backend.delete(`/project/${projectId}/project_tags/${id}`);
  },
};
